export const CandidateRoutes = {
  Overview: 'overview',
  Create: 'create',
  Detail: 'detail',
  Messages: 'messages',
} as const;
